<section>
  @if (error) {
    <p mat-error>{{ error }}</p>
  }
  <h1>Login</h1>
  <mat-card> Click below to login via PingIdentity </mat-card>
  <section class="actions">
    <button mat-button (click)="login()" [disabled]="loading">
      <mat-icon>account_circle</mat-icon>
      Login with Ping
    </button>
  </section>
</section>
